import { useEffect } from 'react';
import NewHero from './NewHero';
import MentorProfile from './MentorProfile';
import Testimonials from './Testimonials';
import FAQ from './FAQ';
import WebinarSchedule from './WebinarSchedule';
import Pricing from './Pricing';
import CTA from './CTA';
import FloatingCTA from './FloatingCTA';
import TradingResults from './TradingResults';
import { saveUTMParams, trackViewContent } from '../utils/tracking';

function MainLP() {
  useEffect(() => {
    // Save UTM parameters to localStorage
    saveUTMParams();
    
    // Track ViewContent event with page info
    trackViewContent({
      content_name: 'News Hack Landing Page - Main',
      content_category: 'Trading Course',
      content_type: 'landing_page'
    });
  }, []);

  return (
    <div className="overflow-x-hidden">
      <NewHero />
      <MentorProfile />
      <TradingResults />
      <Testimonials />
      <FAQ />
      <WebinarSchedule />
      <Pricing />
      <CTA />
      <FloatingCTA />
    </div>
  );
}

export default MainLP;